<template>
  <div class="main">
    <div class="d-flex justify-content-center" v-if="loadingSpinner">
      <b-spinner
        variant="success"
        label="Spinning"
        style="width: 3rem; height: 3rem"
      ></b-spinner>
    </div>
    <div v-if="apiError" class="alert alert-danger p-2" role="alert">
      An error occurred while fetching data. Please try again later.
    </div>

    <div v-if="!loadingSpinner && !apiError">
      <app-collapse accordion>
        <app-collapse-item title="Summary">
          <Summary
            :JobCard="jobId"
            @status="getStatus"
            @bomStatus="getBOMStatus"
            @operationStepsStatus="getOperationStepStatus"
            @warehouseId="getWarehouse"
            @startDate="getDate"
          />
          <SalesOrders
            :salesOrders="jobId.salesOrderDetail"
            :pushOrders="jobId.pushOrderDetail"
          />
        </app-collapse-item>
        <app-collapse-item title="Bill Of Materials">
          <BomTb :JobCard="jobId" @onchange="bomChanged" />
        </app-collapse-item>
        <app-collapse-item title="Operation Steps">
          <!-- <Operations :data="jobId" /> -->
          <Operationprocess @onchange="operationChange" />
          <!-- <b-tabs card>
            <b-tab title="Kanban">
              <Kanban
                v-if="jobId.operationSteps"
                :data="jobId"
                :arrBackLog="getFilteredOperations(0)"
                :arrInProgress="getFilteredOperations(1)"
                :arrHold="getFilteredOperations(2)"
                :arrInWIP="getFilteredOperations(3)"
                :arrInWIP2="getFilteredOperations(4)"
                :arrDone="getFilteredOperations(5)"
              />
            </b-tab>
            <b-tab title="Operation Log">
              <OperationLogs />
            </b-tab>
          </b-tabs> -->
          <b-col cols="12">
            <b-table
              striped
              hover
              responsive
              :per-page="perPage"
              :current-page="currentPage"
              :items="jobId.operationSteps"
              :fields="fields"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              :filter="filter"
              :filter-included-fields="filterOn"
              @filtered="onFiltered"
              class="mt-2"
            >
              <template #cell(show_details)="row">
                <b-form-checkbox
                  v-model="row.detailsShowing"
                  plain
                  class="vs-checkbox-con"
                  @change="row.toggleDetails"
                >
                  <span class="vs-checkbox">
                    <span class="vs-checkbox--check">
                      <i class="vs-icon feather icon-check" />
                    </span>
                  </span>
                  <span class="vs-label">{{
                    row.detailsShowing ? "Hide" : "Show"
                  }}</span>
                </b-form-checkbox>
              </template>

              <template #row-details="row">
                <b-card>
                  <b-row class="mb-2">
                    <!-- Staff Section -->
                    <!-- In template - modify the staff section -->
                    <b-col md="6" class="mb-3">
                      <div>
                        <div class="d-flex align-items-center mb-2">
                          <i class="feather icon-users mr-2 text-primary"></i>
                          <strong>Assigned Staff:</strong>
                        </div>

                        <!-- Multi-select dropdown bound to row-specific selection -->
                        <v-select
                          :key="row.item.id"
                          v-model="row.item.selectedStaff"
                          :options="formattedUsers"
                          :reduce="(user) => user.id"
                          label="name"
                          multiple
                          class="mb-3"
                          :clearable="true"
                          @input="
                            handleStaffChange(row.item.selectedStaff, row.item)
                          "
                        />

                        <!-- Display selected staff -->
                        <!-- <div class="d-flex flex-wrap">
                          <span
                            v-for="staffId in row.item.selectedStaff"
                            :key="staffId"
                            class="badge badge-light-primary mr-1 mb-1 p-2"
                          >
                            {{ getUserName(staffId) }}
                          </span>
                        </div> -->
                      </div>
                    </b-col>

                    <!-- <b-col md="6" class="mb-3">
                      <div class="bg-light p-3 rounded">
                        <div class="d-flex align-items-center mb-2">
                          <i class="feather icon-users mr-2 text-primary"></i>
                          <strong>Assigned Staff:</strong>
                        </div>
                        <div class="d-flex flex-wrap">
                          <span
                            v-for="staffId in parseGuidString(
                              row.item.assignStaff
                            )"
                            :key="staffId"
                            class="badge badge-light-primary mr-1 mb-1 p-2"
                          >
                            {{ getUserName(staffId) }}
                          </span>
                        </div>
                      </div>
                    </b-col> -->

                    <!-- Equipment Section -->
                    <b-col md="6" class="mb-3">
                      <div>
                        <!--class="bg-light p-3 rounded"-->
                        <div class="d-flex align-items-center mb-2">
                          <i class="feather icon-tool mr-2 text-success"></i>
                          <strong>Equipment:</strong>
                        </div>

                        <v-select
                          :key="row.item.id"
                          v-model="row.item.selectedEquipment"
                          :options="formattedEquipment"
                          :reduce="(equipment) => equipment.id"
                          label="name"
                          multiple
                          class="mb-3"
                          :clearable="false"
                          @input="
                            handleEquipmentChange(
                              row.item.selectedEquipment,
                              row.item
                            )
                          "
                        />

                        <!-- <div class="d-flex flex-wrap">
                          <span
                            v-for="equipId in parseGuidString(
                              row.item.equipments
                            )"
                            :key="equipId"
                            class="badge badge-light-success mr-1 mb-1 p-2"
                          >
                            {{ getEquipmentName(equipId) }}
                          </span>
                        </div> -->
                      </div>
                    </b-col>
                    <b-col md="4" class="mb-1">
                      <div class="d-flex align-items-center">
                        <strong class="mr-2">Status: </strong>
                        <b-form-select
                          v-model="row.item.status"
                          :options="options"
                        />
                      </div>
                    </b-col>
                    <b-col md="4" class="mb-1"> </b-col>
                  </b-row>

                  <b-card>
                    <b-card-body>
                      <b-row>
                        <!-- <b-col md="3">
                       <h6 class="mb-2">Sub Operation Step Name: </h6>
                       <h6 class="card-subtitle text-muted">Name here</h6>
                      </b-col> -->

                        <b-col md="3">
                          <h6 class="mb-2">Comment:</h6>
                          <!-- <h6 class="card-subtitle text-muted">
                            {{ row.item.comment }}
                          </h6> -->

                          <b-form-input
                            v-model="row.item.comment"
                            class="w-100"
                          />
                        </b-col>
                        <!-- <b-col md="3">
                       <h6 class="mb-2">Number of Cycles: </h6>
                       <h6 class="card-subtitle text-muted">2</h6>
                      </b-col>
 
                      <b-col md="3">
                       <h6 class="mb-2">Cycle Time: </h6>
                       <h6 class="card-subtitle text-muted">2</h6>
                      </b-col> -->

                        <b-col cols="12">
                          <hr />
                        </b-col>
                      </b-row>
                    </b-card-body>
                  </b-card>

                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    @click="row.toggleDetails"
                  >
                    Hide Details
                  </b-button>
                </b-card>
              </template>

              <template #cell(avatar)="data">
                <b-avatar :src="data.value" />
              </template>

              <template #cell(status)="data">
                <b-badge :variant="status[1][data.item.value]">
                  {{ status[0][data.item.status] }}
                </b-badge>
              </template>

              <template v-slot:cell(actions)="data">
                <b-dropdown
                  variant="link"
                  toggle-class="p-0"
                  no-caret
                  class="m-1"
                >
                  <template #button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="16"
                      class="align-middle text-body"
                    />
                  </template>
                  <b-dropdown-item
                    v-b-modal.modal-edit
                    :to="addtimesheet(data.item.id, jobId.id)"
                  >
                    <feather-icon icon="ClockIcon" class="mr-50" />
                    <span>Time sheet</span>
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>

            <div class="d-flex justify-content-center mb-1">
              <b-spinner
                variant="success"
                label="Spinning"
                block
                v-if="loading"
                style="width: 3rem; height: 3rem"
              ></b-spinner>
            </div>
          </b-col>

          <b-col cols="12">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              align="center"
              size="sm"
              class="my-0"
            />
            <b-form-group>
              Showing
              {{ totalRows > 0 ? perPage * (currentPage - 1) + 1 : 0 }}
              to
              {{
                totalRows > 0 ? Math.min(perPage * currentPage, totalRows) : 0
              }}
              of
              {{ totalRows > 0 ? totalRows : 0 }}
              entries
            </b-form-group>
          </b-col>
        </app-collapse-item>

        <app-collapse-item title="Cost">
          <TotalCost :data="jobId" />
        </app-collapse-item>
        <!-- <app-collapse-item title="Quality Control">
          <OtherCosts
            :Product="jobcard"
            :Items="qualityItems"
            @onchange="qualityChanged"
          />
          <QualityCheck :data="jobId" />
        </app-collapse-item> -->
        <app-collapse-item title="Documents">
          <UploadDocTabs :id="id" />
        </app-collapse-item>
      </app-collapse>
      <b-container class="d-flex justify-content-center py-2">
        <b-row>
          <b-col md="12">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              @click="updateJobCard"
              v-if="!loading"
            >
              <span>Update Job Card</span>
            </b-button>
            <div class="d-flex justify-content-center">
              <b-spinner large v-if="loading" class="mx-2" />
              <span v-if="loading">Loading...</span>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BSpinner,
  BContainer,
  BTabs,
  BTab,
  BFormCheckbox,
  BFormFile,
  BDropdownItem,
  BCard,
  BCardBody,
  BDropdown,
  BLink,
} from "bootstrap-vue";

import { heightTransition } from "@core/mixins/ui/transition";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import SalesOrders from "./components/SalesOrders";
import BomTb from "./components/BomTb";
import Kanban from "./components/Kanban.vue";
import Summary from "./components/Summary.vue";
import Operations from "./components/Operations.vue";
import TotalCost from "./components/TotalCost.vue";
import QualityCheck from "./components/QualityCheck.vue";
import OtherCosts from "./components/QualityVerification.vue";
import { mapActions, mapGetters } from "vuex";
import Ripple from "vue-ripple-directive";
import OperationLogs from "./components/OperationLogs.vue";
import Operationprocess from "./components/Operationprocess.vue";
import users from "@/store/users";
import equipment from "@/store/equipment";
import UploadDocTabs from "./components/UploadDocTabs.vue";
import vSelect from "vue-select";
import Equipment from "@/views/equipment/Equipment.vue";
import warehouse from "@/store/warehouse";
import Swal from "sweetalert2";

export default {
  components: {
    BCard,
    BCardBody,
    BTable,
    vSelect,
    QualityCheck,
    BomTb,
    AppCollapse,
    AppCollapseItem,
    SalesOrders,
    Operations,
    BAvatar,
    TotalCost,
    Kanban,
    BBadge,
    Summary,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BSpinner,
    BContainer,
    BTabs,
    BTab,
    OperationLogs,
    Operationprocess,
    OtherCosts,
    BFormCheckbox,
    BFormFile,
    UploadDocTabs,
    BDropdownItem,
    BDropdown,
    BLink,
  },
  directives: {
    Ripple,
  },
  computed: {
    ...mapGetters("jobcardModule", {
      jobId: "jobId",
      loading: "loading",
    }),
    ...mapGetters("equipmentModule", {
      equipments: "equipments",
      equipmentLoading: "loading",
    }),
    ...mapGetters("userModule", {
      users: "users",
      userLoading: "loading",
    }),
    ...mapGetters("warehouseModule", {
      warehouse: "warehouse",
      loading: "loading",
    }),
    formattedEquipment() {
      console.log("Equipment: ", this.equipments);
      return this.equipments.map((equipment) => ({
        id: equipment.id,
        name: `${equipment.name}`,
        value: equipment.id,
        text: equipment.name,
      }));
    },
    formattedUsers() {
      return this.users.map((user) => ({
        id: user.id,
        name: `${user.firstName} ${user.lastName}`,
        value: user.id,
        text: `${user.firstName} ${user.lastName}`,
      }));
    },
  },
  data() {
    return {
      id: this.$route.params.id,
      addedBom: [],
      perPage: 5,
      pageOptions: [3, 5, 10],
      totalRows: 0,
      currentPage: 0,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      loadingSpinner: true,
      removedBom: [],
      newStatus: 0,
      newBOMStatus: 0,
      newOperationStepStatus: 0,
      newWarehouse: null,
      start: null,
      apiError: false,
      additionalCost: 0,
      qualityItems: [],
      jobcard: {
        operationStep: [],
      },
      fields: [
        // "show_details",
        { key: "name", label: "operation_step" },
        { key: "workStation", label: "work_station" },
        { key: "cycleHours", label: "time_taken" },
        {
          key: "startDate",
          label: "start_date",
          formatter: (value) => new Date(value).toLocaleDateString(),
        },
        {
          key: "endDate",
          label: "end_date",
          formatter: (value) => new Date(value).toLocaleDateString(),
        },
        { key: "actions", label: "Actions" },
        { key: "show_details", label: "" },
      ],
      status: [
        {
          1: "Current",
          2: "Professional",
          3: "Rejected",
          4: "Resigned",
          5: "Applied",
        },
        {
          1: "light-primary",
          2: "light-success",
          3: "light-danger",
          4: "light-warning",
          5: "light-info",
        },
      ],
      selected: "d",
      options: [
        { value: 0, text: "Not Started" },
        { value: 1, text: "Started" },
        { value: 2, text: "On hold" },
        { value: 3, text: "WIP 25%" },
        { value: 4, text: "WIP 50%" },
        { value: 5, text: "WIP 75%" },
        { value: 6, text: "Completed" },
        { value: 7, text: "Cancelled" },
      ],
      file: null,
      file2: null,
    };
  },

  methods: {
    getFilteredOperations(status) {
      let arr = this.jobId.operationSteps.filter((obj) => {
        return obj.status === status;
      });
      return arr;
    },

    // In methods - update the handleStaffChange method
    handleStaffChange(selectedStaffIds, item) {
      // Ensure reactivity by using Vue.set
      this.$set(item, "selectedStaff", selectedStaffIds);
      item.assignStaff = selectedStaffIds.join(", ");
    },

    // Handles equipment selection changes
    handleEquipmentChange(selectedEquipmentIds, item) {
      this.$set(item, "selectedEquipment", selectedEquipmentIds);
      item.equipments = selectedEquipmentIds.join(", ");
    },

    operationChange(operations) {
      let vm = this;
      let oldSteps = vm.jobcard.operationStep;
      vm.jobcard.operationStep = [];
      vm.totalOperationCost = 0;

      console.log("Steps: ", operations);
      operations.forEach(function (item, index) {
        vm.jobcard.operationStep.push({
          name: item.name,
          id: null,
          workstation: item.workstation,
          cycles: item.cycles ? item.cycles : 0,
          cycleHours: item.cycleHours ? item.cycleHours : 0,
          labourId: item.labourId,
          labourCost: item.labourCost || 0,
          equipmentId: item.equipmentId,
          duration: item.duration,
          equipmentCost: item.equipmentCost || 0,
          directCost: item.directCost || 0,
          inDirectCostName: item.indirectCostName || "N/A",
          indirectCost: parseFloat(item.indirectCost) || 0,
          totalCost: item.totalCost || 0,
          itemOperationOrder: index,
          employeeIds: item.users,
          startDate: item.startDate,
          endDate: item.endDate,
          status: item.status ? item.status : 0,
          comment: item.comment,
          equipments: item.equipments,
          operationQuality: vm.getOperationQuality(oldSteps, item.name),
          subOperationSteps: item.substeps.map((substep, index) => {
            return {
              labourId: substep.labourId,
              name: substep.name,
              workstation: substep.workstation,
              labourCost: substep.labourCost,
              indirectCost: substep.indirectCost,
              labourQuantity: substep.labourQty,
              cycles: substep.cycles ? substep.cycles : 0,
              cycleHours: substep.cycleHours ? substep.cycleHours : 0,
              directCost: substep.directCost,
              totalLabourCost: substep.totalLabourCost,
              totalEquipmentCost: substep.totalEquipmentCost,
              totalCost: substep.totalCost,
              InDirectCostName: "N/A",
              itemOperationOrder: index,
              employeeIds: substep.users,
              jobCardSubOperationEquipment: substep.equipments.map(
                (equipment, index) => {
                  return {
                    equipmentId: equipment.equipmentId,
                    equipmentCost: equipment.equipmentCost,
                    equipmentQuantity: equipment.equipmentQty,
                    totalEquipmentCost: equipment.totalEquipmentCost,
                    itemOperationEquipmentOrder: index,
                  };
                }
              ),
            };
          }),
        });
        vm.totalOperationCost += item.totalCost;
      });
      // vm.product.purchasePrice = (
      //   parseFloat(this.totalBomCost) + parseFloat(this.totalOperationCost)
      // ).toFixed(2);
      // vm.pricingChanged(vm.product);
      console.log("Final operationStep array: ", vm.jobcard.operationStep);
      vm.refreshQualityItems(vm.jobcard);
      console.log(vm.jobcard);
    },
    getOperationQuality(oldSteps, currentName) {
      console.log("Old Steps: ", oldSteps);
      let step = oldSteps.filter((obj) => {
        return obj.name === currentName;
      });
      console.log("Filtered step: ", step);
      if (step.length > 0) {
        return step[0].operationQuality;
        console.log("test step", step[0].operationQuality);
      }
      return [];
    },
    refreshQualityItems(jobcard) {
      let vm = this;
      vm.qualityItems = [];
      let serial = 1;
      jobcard.operationStep.forEach(function (step) {
        step.operationQuality.forEach(function (qitem) {
          vm.qualityItems.push({
            serial: serial,
            operationName: step.name,
            name: qitem.name,
            minValue: qitem.minValue,
            maxValue: qitem.maxValue,
          });
        });
      });
    },
    qualityChanged(jobcard) {
      this.jobcard = jobcard;
    },
    showSuccess() {
      this.$swal({
        title: "Job Card Updated!",
        text: "You have successfully updated a Job Card !",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      }).then(() => {
        // Redirect to the Job Card List page after successful update
        this.$router.push({ name: "jobcard-list" });
      });
    },
    getStatus(data) {
      this.newStatus = data;
    },
    getBOMStatus(data) {
      this.newBOMStatus = data;
    },
    getOperationStepStatus(data) {
      this.newOperationStepStatus = data;
    },
    getDate(data) {
      console.log("datawarehousesdfghjertyurtyu", data);
      this.start = data;
    },
    getWarehouse(data) {
      console.log("datawarehouse", data);
      this.newWarehouse = data;
    },
    formatFieldName(fieldName) {
      const indexMatch = fieldName.match(/\[(\d+)\]/);
      const stepNumber = indexMatch ? parseInt(indexMatch[1]) + 1 : null;

      const cleanName = fieldName.replace(/.*\./, "");

      const formattedName = cleanName
        .replace(/([A-Z])/g, " $1")
        .trim()
        .toLowerCase();

      if (fieldName.includes("JobCardOperationSteps")) {
        return `${formattedName} in operation step ${stepNumber}`;
      }

      return formattedName;
    },

    getErrorDescription(fieldName, error) {
      const errorMappings = {
        required: `Please provide a ${this.formatFieldName(fieldName)}`,
        maxlength: `${this.formatFieldName(fieldName)} is too long`,
        minlength: `${this.formatFieldName(fieldName)} is too short`,
        pattern: `${this.formatFieldName(fieldName)} has an invalid format`,
        email: "Please enter a valid email address",
        min: `${this.formatFieldName(fieldName)} is too small`,
        max: `${this.formatFieldName(fieldName)} is too large`,
      };

      for (const [key, message] of Object.entries(errorMappings)) {
        if (error.toLowerCase().includes(key)) {
          return message;
        }
      }

      return `${this.formatFieldName(fieldName)}: ${error}`;
    },

    getErrorString(data) {
      let msg = null;
      if (data.errors) {
        let errors = data.errors;
        msg = "<div class='error-container'>";
        msg += "<p>Please check the following:</p>";

        const errorList = [];
        for (const [prop, errorMessages] of Object.entries(errors)) {
          if (prop !== "request") {
            errorMessages.forEach((error) => {
              errorList.push(this.getErrorDescription(prop, error));
            });
          }
        }

        // bullet list for errors
        msg += "<ul style='list-style-type: none; padding-left: 0;'>";
        errorList.forEach((error) => {
          msg += `<li style='margin-bottom: 8px;'>⚠️ ${error}</li>`;
        });
        msg += "</ul>";
        msg += "</div>";
      } else if (data.message) {
        msg = "<div class='error-container'>";
        msg += "<p>Please check the following:</p>";
        msg += `<p>${data.message}</p>`;
        msg += "</div>";
      }
      return msg;
    },

    errorAdd(data) {
      let msg = null;
      if (data) msg = this.getErrorString(data);
      this.$swal({
        title: "Something's not quite right",
        html: msg ?? data,
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    // error
    // errorAdd(data) {
    //   let msg = null;
    //   if (data) msg = this.getErrorString(data);
    //   this.$swal({
    //     title: "Error!",
    //     html: msg ?? data,
    //     icon: "error",
    //     customClass: {
    //       confirmButton: "btn btn-primary",
    //     },
    //     buttonsStyling: false,
    //   });
    // },
    // getErrorString(data) {
    //   let msg = null;
    //   if (data.errors) {
    //     let errors = data.errors;
    //     msg = "<div>";
    //     msg += "<p>Cannot post your request due to the following errors:</p>";
    //     for (var prop in errors) {
    //       if (
    //         Object.prototype.hasOwnProperty.call(errors, prop) &&
    //         prop !== "request"
    //       ) {
    //         msg += "<p>";
    //         msg += prop.replace("$.", "");
    //         msg += ": ";
    //         msg += errors[prop].toString().replace("$.", "");
    //         msg += "</p>";
    //       }
    //     }
    //     msg += "</div>";
    //   } else if (data.message) {
    //     msg = "<div>";
    //     msg += "<p>Cannot post your request due to the following errors:</p>";
    //     msg += data.message;
    //     msg += "</div>";
    //   }
    //   return msg;
    // },
    ...mapActions("jobcardModule", [
      "getJobcardIdAction",
      "updateJobcardAction",
    ]),
    ...mapActions("equipmentModule", ["getEquipmentListAction"]),
    ...mapActions("userModule", ["getUserListAction"]),
    ...mapActions("warehouseModule", ["getWarehouseListAction"]),

    bomChanged(addedBom, removedBom) {
      this.addedBom = addedBom;
      this.removedBom = removedBom;
    },

    updateJobCard() {
      console.log(this.jobId.transportCost);
      Swal.fire({
        title: "Updating Job Card...",
        text: "Please wait while we process your request.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      console.log("startdatessssss", this.start);

      if (this.start == null) {
  Swal.fire({
    title: "Missing Start Date",
    text: "Please select a start date before updating.",
    icon: "warning",
    allowOutsideClick: true,
  });

  // make sure no loading modals stay open
  Swal.hideLoading();
  Swal.close(); 

  return;
}

      let payload = {
        id: this.jobId.id,
        status: this.newStatus,
        bomStatus: this.newBOMStatus,
        operationStepsStatus: this.newOperationStepStatus,
        deliveryDate: this.jobId.deliveryDate,
        startDate: this.start,
        warehouseId: this.newWarehouse,
        endDate: this.jobId.endDate,
        plannedCost: parseFloat(this.jobId.plannedCost)
          ? parseFloat(this.jobId.plannedCost)
          : 0,
        actualCost: parseFloat(this.jobId.actualCost)
          ? parseFloat(this.jobId.actualCost)
          : 0,
        additionalCost: parseFloat(this.jobId.additionalCost)
          ? parseFloat(this.jobId.additionalCost)
          : 0,
        additionalCostDetails: this.jobId.additionalCostDetails,
        totalCost: parseFloat(this.jobId.totalOperationCost)
          ? this.jobId.totalOperationCost
          : 0,
        bomDetails: [],
        removeBOMObj: [],
        jobCardOperationDetails: [],
        jobCardOperationSteps: [],
        qualityControlDetails: [],
        labourCost: parseFloat(this.jobId.labourCost)
          ? parseFloat(this.jobId.labourCost)
          : 0,
        labourCostDetails: this.jobId.labourCostDetails,
        transportCost: parseFloat(this.jobId.transportCost)
          ? parseFloat(this.jobId.transportCost)
          : 0,
        transportCostDetails: this.jobId.transportCostDetails,
        invoiceAmount: parseFloat(this.jobId.invoiceAmount)
          ? parseFloat(this.jobId.invoiceAmount)
          : 0,
      };

      let vm = this;
      let itemId = null;
      vm.jobId.bom.forEach((obj) => {
        if (itemId === null) {
          itemId = obj.itemId;
        }
        payload.bomDetails.push({
          id: obj.id,
          itemId: obj.itemId,
          uomid: obj.uomId,
          status: obj.status,
          quantity: obj.quantity,
          totalcost: obj.totalCost,
          physicalinventory: obj.physicalinventory,
          warehouseId: obj.wareHouseId,
          materialId: obj.materialId,
        });
      });
      vm.addedBom.forEach((obj) => {
        payload.bomDetails.push({
          itemId: itemId,
          materialId: obj.id,
          uomid: obj.uom,
          status: obj.BOMstatus,
          quantity: obj.quantity,
          totalcost: obj.totalCost,
          physicalinventory: obj.physicalinventory,
          warehouseId: obj.wareHouseId,
        });
      });
      vm.removedBom.forEach((obj) => {
        payload.removeBOMObj.push(obj);
      });
      vm.jobId.operationSteps.forEach((obj) => {
        payload.jobCardOperationDetails.push({
          id: obj.id,
          status: obj.status,
          comments: obj.comment,
          assignStaff: obj.assignStaff,
          equipment: obj.equipments,
        });
      });
      vm.jobcard.operationStep.forEach((obj) => {
        payload.jobCardOperationSteps.push({
          name: obj.name,
          id: obj.id,
          workstation: obj.workstation == null ? " " : obj.workstation,
          cycles: obj.cycles ? obj.cycles : 0,
          cycleHours: obj.cycleHours == "" ? "0" : obj.cycleHours,
          labourId: obj.labourId,
          labourCost: obj.labourCost,
          equipmentId: obj.equipmentId,
          duration: obj.duration,
          equipmentCost: obj.equipmentCost,
          directCost: obj.directCost,
          indirectCostName: obj.inDirectCostName,
          indirectCost: obj.indirectCost,
          totalCost: obj.totalCost ? obj.totalCost : 0,
          operationQuality: obj.operationQuality,
          subOperationSteps: obj.subOperationSteps,
          employeeIds: obj.employeeIds,
          startDate: obj.startDate,
          endDate: obj.endDate,
          status: obj.status ? obj.status : 0,
          comment: obj.comment,
          equipments: obj.equipments,
        });
      });
      vm.jobId.qualityControl.forEach((obj) => {
        payload.qualityControlDetails.push({
          id: obj.id,
          minValue: obj.minValue,
          maxValue: obj.maxValue,
          reading1: obj.reading1,
          reading2: obj.reading2,
          status: obj.status,
        });
      });
      console.log("upon updating job card's final payload: ", payload);
      this.updateJobcardAction(payload)
        .then(() => {
          Swal.close();
          this.showSuccess();
          window.reload();
        })
        .catch((ex) => {
          this.errorAdd(ex.response.data);
        });
    },

    addtimesheet(ops, jc) {
      return `/jobcardtimesheet/add/${ops}/${jc}`;
    },

    parseGuidString(guidString) {
      if (!guidString) return [];
      return guidString
        .split(",")
        .map((guid) => guid.trim())
        .filter((guid) => guid && guid !== '""' && guid !== '"');
    },

    // Gets selected staff for a row
    getSelectedStaff(item) {
      if (!item.assignStaff) return [];
      return this.parseGuidString(item.assignStaff);
    },

    // Gets selected equipment for a row
    getSelectedEquipment(item) {
      if (!item.equipments) return [];
      return this.parseGuidString(item.equipments);
    },

    // // Handles staff selection changes
    // handleStaffChange(selectedStaffIds, item) {
    //   item.assignStaff = selectedStaffIds.join(", ");
    // },

    getUserName(userId) {
      const user = this.users.find(
        (u) => u.id.toString().toLowerCase() == userId.toString().toLowerCase()
      );
      return user ? `${user.firstName} ${user.lastName}` : "Unknown User";
    },

    getEquipmentName(equipmentId) {
      const equipment = this.equipments.find(
        (e) =>
          e.id.toString().toLowerCase() == equipmentId.toString().toLowerCase()
      );
      return equipment ? equipment.name : "Unknown Equipment";
    },

    async loadInitialData() {
      this.loadingSpinner = true;
      try {
        await Promise.all([
          this.getJobcardIdAction(this.id),
          this.getEquipmentListAction(),
          this.getUserListAction(),
        ]);

        if (this.jobId) {
          this.newWarehouse = this.jobId.warehouseId;
        }

        // Process initial selections for each operation step
        if (this.jobId && this.jobId.operationSteps) {
          console.log("steps", this.jobId.operationSteps);
          this.jobId.operationSteps.sort((a, b) =>
            a.startDate.localeCompare(b.startDate)
          );
          this.jobId.operationSteps.forEach((step) => {
            // Initialize selections
            step.selectedStaff = this.parseGuidString(step.assignStaff);
            //step.selectedStaff = this.getSelectedStaff(step);
            step.selectedEquipment = this.parseGuidString(step.equipments);
            //step.selectedEquipment = this.getSelectedEquipment(step);
          });
        }

        this.totalRows = this.jobId.operationSteps.length;
      } catch (ex) {
        this.jobId = null;
        this.apiError = true;
      } finally {
        this.loadingSpinner = false;
      }
    },
  },

  beforeMount() {
    this.getWarehouseListAction();
  },

  async mounted() {
    await this.loadInitialData();
    console.log("Equipment: ", this.equipments);
    console.log("Users: ", this.users);
    // setTimeout(() => {
    //   this.loadingSpinner = false;
    // }, 5000);
    // await this.getJobcardIdAction(this.id)
    //   .then(() => {
    //     this.totalRows = this.jobId.operationSteps.length;
    //   })
    //   .catch((ex) => {
    //     this.jobId = null;
    //     this.apiError = true;
    //   });
  },
  watch: {
    "jobId.operationSteps": {
      handler(newVal) {
        newVal.forEach((step) => {
          if (!step.selectedStaff) {
            this.$set(
              step,
              "selectedStaff",
              this.parseGuidString(step.assignStaff)
            );
          }
          if (!step.selectedEquipment) {
            this.$set(
              step,
              "selectedEquipment",
              this.parseGuidString(step.equipments)
            );
          }
        });
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>